import React from 'react';
import Downshift from 'downshift';
import get from 'lodash.get';

import FormError from '../FormError';
import InputLabel from '../InputLabel';
import SelectButton from './SelectButton';
import SelectItems from './SelectItems';

const isObject = thing => typeof thing === 'object';
const itemToName = item => get(item, 'name', item);
const itemToValue = item => get(item, 'value', item);
const optionForValue = (options, value) =>
  options.find(option => option.name === value || option.value === value) || value;

export default class Select extends React.Component {
  render() {
    const {
      bg,
      border,
      borderRadius,
      error,
      label,
      options,
      onChange,
      placeholder,
      value: propsValue,
      textOnly,
      topContent,
      textStyle = 'caption',
      width
    } = this.props;

    if (textOnly) {
      return get(propsValue, 'name', propsValue);
    }

    const unGroupedOptions = [].concat(...options);
    const value = isObject(propsValue)
      ? propsValue
      : optionForValue(unGroupedOptions, propsValue);

    return (
      <>
        <Downshift
          selectedItem={itemToValue(value)}
          itemToString={itemToValue}
          onChange={onChange}
        >
          {({
            isOpen,
            getInputProps,
            getLabelProps,
            getToggleButtonProps,
            getItemProps,
            highlightedIndex,
            selectedItem
          }) => (
            <div onClick={e => e.stopPropagation()}>
              {label ? <InputLabel {...getLabelProps()}>{label}</InputLabel> : null}
              <SelectButton
                bg={bg}
                border={border ? border : error ? 'error' : 'divider'}
                borderRadius={borderRadius}
                getInputProps={getInputProps}
                getToggleButtonProps={getToggleButtonProps}
                placeholder={placeholder}
                selectedItem={itemToName(value)}
                textStyle={textStyle}
                width={width}
              />
              {isOpen ? (
                <SelectItems
                  bg={bg}
                  getItemProps={getItemProps}
                  highlightedIndex={highlightedIndex}
                  options={options}
                  selectedItem={selectedItem}
                  topContent={topContent}
                  unGroupedOptions={unGroupedOptions}
                />
              ) : null}
            </div>
          )}
        </Downshift>
        <FormError error={error} />
      </>
    );
  }
}
